var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_346_10875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5445 7.9348L20.4813 7.99804L20.5371 8.06792C21.8561 9.71933 22.6494 11.81 22.6494 14.083C22.6494 19.412 18.3391 23.733 12.9994 23.733C7.57388 23.733 3.20995 19.2726 3.34934 13.8256L3.34934 13.8255C3.47798 8.68002 7.85336 4.43301 12.9994 4.43301C15.2723 4.43301 17.363 5.22627 19.0252 6.5561L19.0951 6.61201L19.1584 6.54872L19.97 5.73713C19.9702 5.73698 19.9703 5.73682 19.9705 5.73667C20.3553 5.36214 20.964 5.35408 21.3462 5.73622L21.357 5.74705C21.7398 6.12984 21.7303 6.74902 21.357 7.1223L20.5445 7.9348ZM10.8327 1.18301H15.166C15.7066 1.18301 16.1494 1.62574 16.1494 2.16634C16.1494 2.70695 15.7066 3.14967 15.166 3.14967H10.8327C10.2921 3.14967 9.84938 2.70695 9.84938 2.16634C9.84938 1.62574 10.2921 1.18301 10.8327 1.18301ZM13.9827 14.083C13.9827 14.6236 13.54 15.0663 12.9994 15.0663C12.4588 15.0663 12.016 14.6236 12.016 14.083V9.74967C12.016 9.20907 12.4588 8.76634 12.9994 8.76634C13.54 8.76634 13.9827 9.20907 13.9827 9.74967V14.083ZM5.31604 14.083C5.31604 18.3307 8.75165 21.7663 12.9994 21.7663C17.2471 21.7663 20.6827 18.3307 20.6827 14.083C20.6827 9.83528 17.2471 6.39967 12.9994 6.39967C8.75165 6.39967 5.31604 9.83528 5.31604 14.083Z",
    fill: "#404A51",
    stroke: "#F6F7FB",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_346_10875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.6444cafd3f3234ed0517007eeb352938.svg";
export { ForwardRef as ReactComponent };